import { render, staticRenderFns } from "./VoteDetail.vue?vue&type=template&id=c9cef586&scoped=true"
import script from "./VoteDetail.vue?vue&type=script&lang=js"
export * from "./VoteDetail.vue?vue&type=script&lang=js"
import style0 from "./VoteDetail.vue?vue&type=style&index=0&id=c9cef586&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cef586",
  null
  
)

export default component.exports